// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyBanner_container__t1KoM","content":"CompanyBanner_content__6iJeJ","title":"CompanyBanner_title__IrzcH"};